'use client';

import { createContext, useContext } from 'react';

/**
 * Row density of a menu.
 * `sm` matches the Figma Desktop rows, `standard` the Mobile ones.
 */
export type MenuSize = 'sm' | 'standard';

export type MenuSizeContextValue = {
  size: MenuSize;
};

const MenuSizeContext = createContext<MenuSizeContextValue>({ size: 'sm' });

export const MenuSizeProvider = MenuSizeContext.Provider;

export const useMenuSize = () => useContext(MenuSizeContext);
